import { Link } from "react-router-dom";
import { BrandMark } from "./BrandMark";
import { PATHS } from "./paths";

const BTN = "inline-flex items-center justify-center gap-2 rounded-md px-5 py-[13px] text-[15px] no-underline";
const PRIMARY = "font-semibold bg-rs-green !text-rs-black hover:bg-rs-light-green";
const GHOST =
  "font-normal bg-transparent !text-rs-off-white border border-[#2c3126] hover:border-rs-green hover:!text-rs-green";

export function Landing() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-rs-off-black text-rs-off-white">
      <div className="max-w-[440px] px-6 text-center">
        <div className="mb-7 flex items-center justify-center gap-[11px]">
          <BrandMark className="block h-[30px] w-auto" />
          <span className="text-[24px] font-semibold tracking-[-0.015em] text-white">ResinSmart</span>
        </div>
        <h1 className="!mb-3 !text-[24px] !font-semibold !text-white">RESIN8 Data Intake</h1>
        <p className="!mb-8 text-[14.5px] leading-[1.55] text-rs-light-gray">
          Internal tool for entering client purchase data, producer price nominations, spot quotes and technical data
          sheets into RESIN8.
        </p>
        <div className="flex flex-col gap-3">
          <Link className={`${BTN} ${PRIMARY}`} to={PATHS.intake}>Data Intake Tool</Link>
          <Link className={`${BTN} ${GHOST}`} to={PATHS.data}>Resin8 Data</Link>
          <Link className={`${BTN} ${GHOST}`} to={PATHS.cockpit}>Consultant Cockpit</Link>
          <Link className={`${BTN} ${GHOST}`} to={PATHS.plantRegistry}>Plant Registry</Link>
        </div>
      </div>
    </div>
  );
}
